import StrategyTemplatesPortfolio from '@/Core.Service.Domain/Strategies/StrategyTemplates/Views';
import StrategyTemplatesListVue from '@/Core.Service.Domain/Strategies/StrategyTemplates/Views/StrategiesTemplatesListView.vue';

import CreateStrategyTemplate from '@/Core.Service.Domain/Strategies/StrategyTemplates/Components/CreateStrategyTemplate.vue';
import EditStrategyTemplate from '@/Core.Service.Domain/Strategies/StrategyTemplates/Components/EditStrategyTemplate.vue';

// These are old views. They should be refactored to be part of the new Strategies Domain.
const StrategyTemplatesCreateRoute = {
  path: 'create',
  name: 'StrategyTemplatesCreate',
  component: CreateStrategyTemplate,
  meta: { permission: 'strategy-templates:create' },
};

const StrategyTemplatesEditRoute = {
  path: 'edit-strategy-template/:strategyTemplateId',
  name: 'StrategyTemplatesEdit',
  component: EditStrategyTemplate,
  meta: { permission: 'strategy-templates:update' },
};
// End of old views.

const StrategyTemplatesListRoute = {
  path: 'all',
  name: 'StrategyTemplatesList',
  component: StrategyTemplatesListVue,
  meta: {
    permission: 'strategy-templates:read',
    label: 'Strategy Templates',
    toolTip: 'Strategy Template',
  },
};

export const StrategyTemplatesRoute = {
  path: 'strategy-templates',
  name: 'StrategyTemplates',
  component: StrategyTemplatesPortfolio,
  children: [
    StrategyTemplatesCreateRoute,
    StrategyTemplatesEditRoute,
    StrategyTemplatesListRoute,
  ],
  meta: {
    permission: 'strategy-templates:read',
    label: 'Strategy Templates',
    toolTip: 'Strategy Template',
  },
  redirect: { name: 'StrategyTemplatesList' },
};
